<template>
  <div class="settings-problems">
    <!-- Advanced/simplified problem reporting -->
    <ExpandableSettingsItem :title="$t('message.SETTINGS_PROBLEMS_MODE')">
      <div>
        {{ $t("message.DEFAULT_PROBLEM_MODE") }}
        <RadioGroup
          :value="currentTeam.defaultReportingMode"
          :items="modeRadioItems"
          @input="setParams('defaultReportingMode', $event)"
        />
      </div>
    </ExpandableSettingsItem>

    <!-- Customize problem reporting hints -->
    <ExpandableSettingsItem :title="$t('message.CUSTOM_PROBLEM_HINTS')">
      <ProblemHintsEdition
        :hints="currentTeam.customProblemHints"
        :problem-sheet="currentTeam.customHintsProblemSheet"
        company-settings-choice
        @hintsUpdated="setParams('customProblemHints', $event)"
        @problemSheetUpdated="setParams('customHintsProblemSheet', $event)"
      />
    </ExpandableSettingsItem>

    <!-- Customize problem reporting hints -->
    <ExpandableSettingsItem :title="$t('message.SETTINGS_PROBLEMS_ADD_FIELDS')">
      <CheckboxList
        v-model="addFieldsValue"
        :items="addFieldsCheckboxes"
        :display-all-toggle="false"
        :disabled-ids="[0]"
      />
    </ExpandableSettingsItem>
  </div>
</template>

<script>
/**
 * Settings > Problems
 * Allow editing:
 * - default reporting mode
 * - problem reporting hints
 */

// Components
import CheckboxList from '@/components/checkbox-list.vue';
import ExpandableSettingsItem from '@/components/expandable-settings-item.vue';
import ProblemHintsEdition from '@/components/problem-hints-edition.vue';
import RadioGroup from '@/components/radio-group.vue';
// Vuex utils
import { SET_TEAM_PARAM } from '@/store/action-types';

export default {

  name: 'SettingsProblems',

  components: {
    CheckboxList,
    ExpandableSettingsItem,
    ProblemHintsEdition,
    RadioGroup,
  },

  data() {
    return {
      modeRadioItems: [
        { id: 0, label: this.$t('message.SIMPLIFIED_MODE') },
        { id: 1, label: this.$t('message.ADVANCED_MODE') },
      ],
      // Properties used by other components. See src/views/readme.md
      pageTitle: this.$t('message.SETTINGS_PROBLEMS'),
    };
  },

  computed: {
    /** Array: List of selectable fields to display in the list of problems */
    addFieldsCheckboxes() {
      return [
        { id: 0, label: this.$t('message.WHAT'), field: 'lWhat' },
        { id: 1, label: this.$t('message.WHO'), field: 'lWho' },
        { id: 2, label: this.$t('message.WHERE'), field: 'lWhere' },
        { id: 3, label: this.$t('message.WHEN'), field: 'lWhen' },
        { id: 4, label: this.$t('message.HOW'), field: 'lHow' },
        { id: 5, label: this.$t('message.HOW_MUCH'), field: 'lHowMuch' },
        { id: 6, label: this.$t('message.WHY'), field: 'lWhy' },
      ];
    },
    /** Array: Array of selected IDs in the list of fields checkboxes */
    addFieldsValue: {
      get() {
        // Have What always checked
        return [...this.currentTeam.problemListAdditionalFields, 'lWhat']
          .map(field => this.addFieldsCheckboxes.findIndex(cb => cb.field === field));
      },
      set(newVal) {
        // Filter out lWhat as it is checked only visually
        const formattedValue = newVal
          .map(idx => this.addFieldsCheckboxes[idx].field)
          .filter(field => field !== 'lWhat');
        this.setParams('problemListAdditionalFields', formattedValue);
      },
    },
  },

  methods: {
    /** Set company params */
    setParams(field, value) {
      this.$store.dispatch(SET_TEAM_PARAM, { [field]: value });
    },
  },
};
</script>

<style lang="scss">
.settings-problems {
  .checkbox.checkbox--disabled {
    .tick svg {
      color: #adadad !important;
    }
  }
}
</style>
